/* Exit-intent popup.

   Desktop: the cursor leaving the top edge of the window.
   Phones: no cursor exists, so a fast upward flick (after the visitor has scrolled in a bit)
   stands in for it, with an optional timer as a backstop. Without this branch the popup would
   never fire for the majority of visitors.

   Shown once per visitor, then suppressed for the configured number of days. In the theme
   editor it opens straight away and ignores the suppression so it can be styled.
*/
(function () {
  var root = document.getElementById('D2FExit');
  if (!root) return;
  if (document.querySelector('[data-d2f-planner]')) { root.hidden = true; return; }

  var KEY = 'd2f-exit-seen';
  var design = window.Shopify && window.Shopify.designMode;

  var delayMs = parseInt(root.dataset.delay, 10) * 1000 || 0;
  var freqDays = parseInt(root.dataset.frequency, 10) || 30;
  var wantMobile = root.dataset.mobile === 'true';
  var fallbackMs = parseInt(root.dataset.mobileFallback, 10) * 1000 || 0;

  var card = root.querySelector('.d2f-exit__card');
  var form = root.querySelector('form');
  var errorEl = root.querySelector('[data-error]');
  var stepAsk = root.querySelector('[data-step="ask"]');
  var stepDone = root.querySelector('[data-step="done"]');

  var opened = false;
  var armed = false;
  var lastFocus = null;
  var timers = [];

  function suppressed() {
    if (design) return false;
    try {
      var until = parseInt(localStorage.getItem(KEY), 10);
      return until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function suppress() {
    if (design) return;
    try {
      localStorage.setItem(KEY, String(Date.now() + freqDays * 864e5));
    } catch (e) {
      /* private browsing - popup simply shows again next visit */
    }
  }

  function focusables() {
    return root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
  }

  function open() {
    if (opened || suppressed()) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    suppress();
    var first = root.querySelector('input[type="email"]') || root.querySelector('[data-close]');
    if (first) first.focus();
    teardown();
  }

  function close() {
    if (!opened) return;
    opened = false;
    root.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (!opened) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- triggers ---------- */

  function onMouseOut(e) {
    if (!armed || e.relatedTarget || e.clientY > 0) return;
    open();
  }

  var lastY = window.pageYOffset;
  var lastT = Date.now();

  function onScroll() {
    if (!armed) return;
    var y = window.pageYOffset;
    var t = Date.now();
    var dy = lastY - y;
    var dt = t - lastT;
    // a deliberate upward flick: far enough, fast enough, and only once they are into the page
    if (dy > 90 && dt < 320 && lastY > window.innerHeight * 0.4) open();
    lastY = y;
    lastT = t;
  }

  function teardown() {
    timers.forEach(clearTimeout);
    timers = [];
    document.removeEventListener('mouseout', onMouseOut);
    window.removeEventListener('scroll', onScroll);
  }

  function arm() {
    armed = true;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    if (coarse) {
      if (!wantMobile) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      if (fallbackMs) timers.push(setTimeout(open, fallbackMs));
    } else {
      document.addEventListener('mouseout', onMouseOut);
    }
  }

  /* ---------- sign-up ---------- */

  function showCode() {
    stepAsk.hidden = true;
    stepDone.hidden = false;
    var btn = stepDone.querySelector('a, button');
    if (btn) btn.focus();
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.checkValidity()) {
        if (email) email.reportValidity();
        return;
      }
      var submit = form.querySelector('button[type="submit"]');
      if (submit) { submit.disabled = true; submit.textContent = 'Sending...'; }
      if (errorEl) errorEl.hidden = true;

      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('signup failed');
          showCode();
        })
        .catch(function () {
          // Never trap the customer: hand them the code anyway rather than block on our form.
          showCode();
        });
    });
  }

  var copyBtn = root.querySelector('[data-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var value = root.querySelector('[data-code-value]').textContent.trim();
      var done = function () {
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(value).then(done, done);
      else done();
    });
  }

  /* ---------- wiring ---------- */

  root.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  // Closing on any click outside the card, rather than relying on the overlay element alone.
  if (card) card.addEventListener('click', function (e) { e.stopPropagation(); });
  root.addEventListener('click', close);
  document.addEventListener('keydown', onKey);

  if (design) {
    root.hidden = false;
    opened = true;
  } else if (!suppressed()) {
    timers.push(setTimeout(arm, delayMs));
  }
})();
